import { Box, Typography } from '@material-ui/core'
import { useFormContext } from 'react-hook-form'
import PropTypes from 'prop-types'

import { BasePermissionsForm } from '../index'

import constants from 'constants/index'

const SalesForm = ({ permissions, handleChange }) => {
  const { register } = useFormContext()

  const {
    preRegistrationList,
    paymentContractList,
    couponList,
    paymentOrdersList,
    planList,
    sellerList,
    paymentServiceTemplateList,
  } = constants.permissionsLists.collaboratorProfileLists

  return (
    <>
      <Box mt={2} mb={3}>
        <Typography variant="h5">Vendas</Typography>
      </Box>
      <BasePermissionsForm
        title="Clientes e sublicenciamentos"
        permissionsList={preRegistrationList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
      />
      <BasePermissionsForm
        title="Contratos"
        permissionsList={paymentContractList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
      />
      <BasePermissionsForm
        title="Cupons"
        permissionsList={couponList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
      />
      <BasePermissionsForm
        title="Ordens de pagamento"
        permissionsList={paymentOrdersList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
      />
      <BasePermissionsForm
        title="Planos"
        permissionsList={planList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
      />
      <BasePermissionsForm
        title="Vendedores & Parceiros"
        permissionsList={sellerList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
      />
      <BasePermissionsForm
        title="Tipos de serviços"
        permissionsList={paymentServiceTemplateList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
      />
    </>
  )
}

SalesForm.propTypes = {
  register: PropTypes.func,
  permissions: PropTypes.object,
  handleChange: PropTypes.func,
}

export default SalesForm
